import { Unit } from '@app/src/types/resourceExplorer'

const SUFFIXES = [
  { symbol: 'T', value: 1_000_000_000_000 },
  { symbol: 'B', value: 1_000_000_000 },
  { symbol: 'M', value: 1_000_000 },
  { symbol: 'k', value: 1_000 },
]

// If you add a new currency here, make sure it also exists in the UnitTypes table in the database, with the same symbol
const CURRENCIES_FOR_SPEND: { symbol: string; currencyString: (s: string) => string }[] = [
  { symbol: 'EUR', currencyString: s => `€${s}` },
  { symbol: 'USD', currencyString: s => `$${s}` },
  { symbol: 'GBP', currencyString: s => `£${s}` },
  { symbol: 'SEK', currencyString: s => `${s} kr` },
  { symbol: 'NOK', currencyString: s => `${s} kr` },
]

export const CURRENCY_SYMBOLS_FOR_SPEND = CURRENCIES_FOR_SPEND.map(c => c.symbol)

const addCurrencySuffix = (amount: number) => {
  const suffixToUse = SUFFIXES.find(s => amount > s.value)
  if (!suffixToUse) return Math.round(amount).toString()
  const convertedAmount = Math.round(amount / suffixToUse.value)
  return `${convertedAmount}${suffixToUse.symbol}`
}

export const toCurrencyString = (amount: number, currencyUnit?: Unit) => {
  const amountWithSuffix = addCurrencySuffix(amount)
  if (!currencyUnit?.symbol) return amountWithSuffix

  const uppercaseCurrencySymbol = currencyUnit.symbol.toUpperCase()
  const matchingCurrency = CURRENCIES_FOR_SPEND.find(c => c.symbol === uppercaseCurrencySymbol)
  if (!matchingCurrency) return `${amountWithSuffix} ${currencyUnit.symbol}`
  return matchingCurrency.currencyString(amountWithSuffix)
}
